import { render } from "./moreSelect.vue?vue&type=template&id=5fd0c801&scoped=true"
import script from "./moreSelect.vue?vue&type=script&lang=js"
export * from "./moreSelect.vue?vue&type=script&lang=js"

import "./moreSelect.vue?vue&type=style&index=0&id=5fd0c801&scoped=true&lang=css"

import exportComponent from "C:\\src\\web\\finance\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fd0c801"]])

export default __exports__